import React, { memo, useCallback } from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import CustomerCreateFormInner from './customer-create-form-inner/CustomerCreateFormInner';
import { createCustomerFormYopValidation } from './validation';
import validate from '../../utils/validate';
import { addNewCompany } from '../../redux/customers/customersActions';

const CustomerCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const createCustomerInitialValues = {
    companyName: '',
    companyEmail: '',
    companyContact: '',
    companyCity: '',
    companyAddress: '',
    companyZip: '',
    companyUsers: [],
    enabledProducts: [],
    assignedProjects: [],
    assignedAssistants: [],
    assignedAIChats: [],
    assignedAIMedia: [],
  };

  const handleCreateCustomer = useCallback(
    async (values, form) => {
      await dispatch(addNewCompany(values));
      form.restart();
      navigate('/customers');
    },
    [dispatch, navigate],
  );

  return (
    <Form
      initialValues={createCustomerInitialValues}
      onSubmit={handleCreateCustomer}
      subscription={{
        submitting: true,
        submitFailed: true,
        submitSucceeded: true,
      }}
      validate={(values) => validate(values, createCustomerFormYopValidation())}
      render={({ handleSubmit }) => <CustomerCreateFormInner onSubmit={handleSubmit} />}
    />
  );
};

export default memo(CustomerCreate);
